import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ROOM_CONFIG_DESK = FORM_FIELDS.INVENTORY.ROOM_CONFIG.DESK;

export const roomConfigBuildingValidationSchema = yup.object().shape({
  [ROOM_CONFIG_DESK.OFFICE]: yup
    .string()
    .required("Office Location is required"),

  [ROOM_CONFIG_DESK.BUILDING]: yup
    .string()
    .required("Building Location is required"),

  [ROOM_CONFIG_DESK.FLOOR]: yup.string().required("Floor is Required"),
  [ROOM_CONFIG_DESK.ROOM_TYPE]: yup.string().required("Room Type is required"),
  [ROOM_CONFIG_DESK.ROOM]: yup.string().required("Room  is required"),
  [ROOM_CONFIG_DESK.TYPE]: yup.string().required("Type  is required"),
  [ROOM_CONFIG_DESK.DESK_NUMBER]: yup
    .string()
    .required("Desk Number is Required"),
  [ROOM_CONFIG_DESK.PABX_NUMBER]: yup
    .number()
    .nullable()
    .min(0, "PABX number cannot be negative")
    .typeError("PABX must be number ")
    .max(9999, "PABX number cannot have more than 4 digits"),
});

export type RoomConfigBuildingSchemaType = yup.InferType<
  typeof roomConfigBuildingValidationSchema
>;
